module.exports = __webpack_public_path__ + "img/e-cabriolet.028346be.png";